import React from 'react';
import PropTypes from 'prop-types';
import { Col, CustomInput, FormGroup } from 'reactstrap';
import { RowLabel } from './RowLabel';

export const NumericInputRow = props => {
  const {
    title,
    name,
    value,
    change = () => console.log('Info: no change handler specified.'),
    placeholder = null,
    tooltip = null,
    required = false,
    min = null,
    max = null,
    step = 1
  } = props;

  return (
    <FormGroup row>
      <RowLabel name={name} title={title} tooltip={tooltip} />

      <Col lg={8} xl={9}>
        <CustomInput
          id={name}
          type={'number'}
          name={name}
          autoComplete='off'
          className={'question custom-number'}
          placeholder={placeholder}
          value={value}
          onChange={change}
          min={min}
          max={max}
          step={step}
          required={required}
        />
        <label htmlFor='name'>
          <span />
        </label>
      </Col>
    </FormGroup>
  );
};

NumericInputRow.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  change: PropTypes.func,
  tooltip: PropTypes.string,
  placeholder: PropTypes.string
};
